import { render, staticRenderFns } from "./addRoles.vue?vue&type=template&id=2714e0c5&scoped=true&"
import script from "./addRoles.vue?vue&type=script&lang=js&"
export * from "./addRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2714e0c5",
  null
  
)

export default component.exports